export default __webpack_public_path__ + "static/media/controls_readiness_score.ae931e24.svg";